<template>
  <div class="h-[37px] border border-osn-grey-03 rounded-full flex items-center">
    <svg-icon name="filter"
              size="20"
              class="ml-[12px]"></svg-icon>
    <el-select
        v-model="filter"
        @change="filterChange"
        class="filter-dropdown"
        clearable
        placeholder="排序"
        popper-class="filter-option"
    >
      <el-option
          v-for="item in filterOption"
          :key="item.value"
          :label="`${item.label}`"
          :value="item.value"
      >
        <span class="text-osn-dark-grey-00 font-normal">{{ item.label }}</span>

      </el-option>

    </el-select>
  </div>
</template>
<script setup>

import {computed, onMounted, onUnmounted, ref} from 'vue'
import {useSearchQueryStore} from "@/stores/searchQuery.js";
import {useSearchWithStore} from "@/composables/useSearchWithStore";

const searchQueryStore = useSearchQueryStore()
const {handleSearchWithStore} = useSearchWithStore()


const filter = ref('')
const filterOption = computed(() => {
  const priceFilterValue = determinePriceFilterValue(
      searchQueryStore.getRentTimeSelected.begin_time,
      searchQueryStore.getRentTimeSelected.rent_type
  );

  return [
    {
      label: '上架日期 (由新到舊)',
      value: 'created_date-1',
    },
    {
      label: '價格 (由低到高)',
      value: priceFilterValue + '-0',
    },
    {
      label: '價格 (由高到低)',
      value: priceFilterValue + '-1',
    },
    {
      label: '坪數 (由小到大)',
      value: 'room_size-0',
    },
    {
      label: '坪數 (由大到小)',
      value: 'room_size-1',
    },
  ];
});


onMounted(() => {
  // todo 有需要清除，單獨清除sort就好
  // searchQueryStore.clearPagination()

  const {begin_time, rent_type} = searchQueryStore.getRentTimeSelected;
  let {sort, dir} = searchQueryStore.getPagination;

  // 給 sort 設置預設值 'created_date'，當 sort 為空時
  sort = sort || 'created_date';

  // 根據租金時間選擇來判斷價格過濾值
  const priceFilterValue = determinePriceFilterValue(begin_time, rent_type);

  // 判斷排序方式是否包含 'price' 沒有就用 sort
  filter.value = sort.includes('price')
      ? `${priceFilterValue}-${dir}`
      : `${sort}-${dir}`;

  // 初始化 filter 時檢查是否存在於 filterOption 中，若不存在則使用預設值
  const filterExists = filterOption.value.some(option => option.value === filter.value);

  if (!filterExists) {
    filter.value = '';
  }

})
onUnmounted(() => {
  // searchQueryStore.clearPagination()
})

function parseFilter(value) {
  if (!value) {
    return
  }

  const [sortKey, dir] = value.split('-');
  const dirNum = Number(dir);

  return {
    sort: sortKey,
    dir: dirNum
  };
}

function determinePriceFilterValue(begin_time, rent_type) {
  const priceMapping = {
    '': 'all_price',
    1: 'daily_price',
  };


  // o沒有日期   打勾  daily_price
  //  o有日期    打勾 daily_price
  //  o有日期  沒打勾 hourly_price
  // o沒有日期   沒打勾  all_price
  return priceMapping[rent_type] || priceMapping[begin_time] || 'hourly_price'
}


function filterChange() {
  searchQueryStore.initGeoSearch()
  searchQueryStore.setPagination(parseFilter(filter.value))
  handleSearchWithStore()
}

</script>

<style scoped
       lang="scss">
.filter-dropdown {
  @apply cursor-pointer;
  --el-select-input-focus-border-color: '#FFFFFF';
  --el-select-border-color-hover: '#FFFFFF';

  :deep(.el-select__wrapper) {
    @apply w-[140px];
    background-color: transparent;
    border-radius: 0;
    box-shadow: 0 0 0 0;
    padding: 0 8px;
  }

}


</style>
